<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 11:16:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/purchase/components/OrderPrice/index.vue
-->
<template>
  <!-- 订单详情价格信息 -->
  <div class="det_price">
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>商品总额</div>
      <div>{{ preCheckout.price | currency(false) }}</div>
    </div>
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>税率费用</div>
      <div>{{ preCheckout.tax | currency(false) }}</div>
    </div>
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>运费</div>
      <div v-if="preCheckout.freight">
        {{ preCheckout.freight | currency(false) }}
      </div>
      <div v-if="!preCheckout.freight">免运费</div>
    </div>
    <div
      v-if="false"
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>活动扣减</div>
      <div>-¥30</div>
    </div>
    <div
      v-if="false"
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>优惠券</div>
      <div>-¥20</div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.det_price {
  background: #fff;
  margin-top: 12px;
  padding: 24px 12px 0;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 24px;
  }
}
</style>
